import { render } from "./CitiesForm.vue?vue&type=template&id=1446e3b0"
import script from "./CitiesForm.vue?vue&type=script&lang=js"
export * from "./CitiesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__